export enum Countries {
  USA = 'USA',
  MX = 'MX',
  COL = 'COL',
}

export const NON_SWIFT_COUNTRIES_ISO_CODES = ['US', 'CO', 'MX'];

export enum Currencies {
  USD = 'USD',
  MXN = 'MXN',
  COP = 'COP',
}

export enum ExtendedCurrencies {
  EUR = 'EUR',
  PEN = 'PEN',
  CLP = 'CLP',
  BRL = 'BRL',
  GBP = 'GBP',
  CAD = 'CAD',
  HKD = 'HKD',
  JPY = 'JPY',
  CHF = 'CHF',
  CNY = 'CNY',
  AUD = 'AUD',
  PLN = 'PLN',
}

export enum ContactTypeId {
  REGULAR_CONTACT = 1,
  SWIFT_CONTACT = 2,
}

export enum LocalStorageKeys {
  TOKEN = 'token',
  LANGUAGE = 'language',
  REFRESH = 'refresh',
  USER_KYC = 'userKyc',
  IS_KYC = 'is_kyc',
  VISIT_COUNT = 'visitCount',
  ONBOARDING_PROCESS_DATA = 'onboardingProcessData',
  RESET_EMAIL_PASSWORD = 'resetEmailPassword',
  LAST_LOGIN_TIME = 'lastLoginTime',
  USER_EMAIL = 'userEmail',
  DO_NOT_SHOW_CONVERT = 'doNotShowConvert',
  MIGRATION_ID_TOKEN = 'migration_id_token',
}

export enum AuthResponseCodes {
  SUCCESS = 'SUCCESS',
  FORCE_PASSWORD_RESET_MIGRATION = 'FORCE_PASSWORD_RESET_MIGRATION',
}

export enum SessionStorageKeys {
  ID_TOKEN = 'id_token',
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  ROLES = 'user_roles',
  PERMISSIONS = 'user_permissions',
  COGNITO_UUID = 'cognito_uuid',
}

export enum DecimalDigits {
  DEFAULT_DIGITS = 2,
  DEFAULT_MIN_DIGITS = 2,
  COMPLETE_DIGITS = 10,
}

export enum CurrencyLocales {
  USD = 'en-US',
  MXN = 'es-MX',
  COP = 'es-MX', // To avoid formatting issues with COP
  EUR = 'en-US',
  PEN = 'es-PE',
  CLP = 'es-CL',
  BRL = 'pt-BR',
  JPY = 'ja-JP',
  HKD = 'zh-HK',
  CHF = 'es-MX', // To avoid formatting issues with CHF
  CAD = 'en-CA',
  GBP = 'en-GB',
  CNY = 'zh-CN',
}

export enum BankAccountFieldType {
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  CLABE = 'CLABE',
  IBAN = 'IBAN',
  ACH_ROUTING = 'ACH_ROUTING',
  WIRE_ROUTING = 'WIRE_ROUTING',
  TRANSIT_NUMBER = 'TRANSIT_NUMBER',
  INSTITUTION_NUMBER = 'INSTITUTION_NUMBER',
}

export enum WalletTypes {
  GLOBAL_ACCOUNT = 1,
  LOAN_ACCOUNT = 2,
}
